import { useState, useCallback, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Row, Card, Button, message, Form, Switch } from "antd";
import { Input, Select, Space } from "antd";
import axios from "axios";
import Spinner from "../components/common/Spinner/Spinner";
import CustomSwitch from "../components/common/Switch/CustomSwitch";
import { useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const societatiPaza = [
  {
    label: "AKB SECURITY",
    value: "AKB SECURITY",
  },
  {
    label: "ELNET SECURITY",
    value: "ELNET SECURITY",
  },
  {
    label: "ORION SECURITY",
    value: "ORION SECURITY",
  },
  {
    label: "RPG SECURITY",
    value: "RPG SECURITY",
  },
  {
    label: "SSG SECURITY",
    value: "SSG SECURITY",
  },
  {
    label: "SSG FIRE&RESCUE",
    value: "SSG FIRE&RESCUE",
  },
  {
    label: "HIGHLANDER GUARD",
    value: "HIGHLANDER GUARD",
  },
];

function AddCompany() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();

  const [companyName, setCompanyName] = useState();

  const [loading, setLoading] = useState(false);
  // const [username, setUsername] = useState();
  // const [password, setPassword] = useState();
  // const [confirmPassword, setConfirmPassword] = useState();
  // const [company, setCompany] = useState();
  // const [clients, setClients] = useState([]);
  // const [locations, setLocations] = useState([]);
  // const [selectedLocations, setSelectedLocations] = useState([]);
  // const [email, setEmail] = useState();
  // const [phoneNumber, setPhoneNumber] = useState();
  // const [description, setDescription] = useState();
  // const [role, setRole] = useState(["ROLE_USER"]);
  // const [needsNFC, setNeedsNFC] = useState(true);

  const [allLocations, setAllLocations] = useState([]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Company added successfully",
    });
  };
  const error = (e) => {
    messageApi.open({
      type: "error",
      content: `Company was not added. Please try again later. (${e})`,
    });
  };

  // const availableLocations = locations.map((location) => {
  //   return {
  //     label: location.locationName,
  //     value: location.id,
  //   };
  // });

  // const getLocationsByClient = async (clients) => {
  //   const myArray = [];
  //   for (const client of clients) {
  //     const token = localStorage.getItem("token");
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         process.env.REACT_APP_API_URL+ `location/getAllLocationsByClient?client=${client}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       console.log(response);
  //       myArray.push(...response.data);
  //       console.log("myArray: ", myArray);
  //       setLocations(myArray);
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };

  // const handleChange2 = useCallback(
  //   (item) => {
  //     setClients(item);
  //     setLocations([]);
  //     console.log(item);
  //
  //     getLocationsByClient(item);
  //   },
  //
  //   [locations, clients]
  // );

  // const handleChange4 = (item) => {
  //   setCompany(item);
  //   console.log(item);
  // };

  // const handleChange3 = (item) => setSelectedLocations(item);

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const addCompany = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    if (companyName) {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "company/addCompany",
          {
            id: uuidv4(),
            companyName: companyName,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  // const initialLocations = locations.filter((o1) =>
  //   selectedLocations?.some((o2) => o1.id === o2)
  // );

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  return (
    <>
      {contextHolder}

      <Card
        bordered={false}
        className="header-solid mb-24"
        title={
          <>
            <h6 className="font-semibold">Add Company</h6>
            <p>Add company information below</p>
          </>
        }
      >
        <Row
          style={{
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            style={{
              width: "80%",
            }}
            scrollToFirstError
          >
            <Form.Item
              name="companyName"
              label="Company Name"
              tooltip="Please provide a company name"
              rules={[
                {
                  required: true,
                  message: "Please input the company name!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </Form.Item>

            {/*<Form.Item*/}
            {/*  name="password"*/}
            {/*  label="Password"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Please input the user password!",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*  hasFeedback*/}
            {/*>*/}
            {/*  <Input.Password*/}
            {/*    value={password}*/}
            {/*    onChange={(e) => setPassword(e.target.value)}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="confirm"*/}
            {/*  label="Confirm Password"*/}
            {/*  dependencies={["password"]}*/}
            {/*  hasFeedback*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Please confirm the user password!",*/}
            {/*    },*/}
            {/*    ({ getFieldValue }) => ({*/}
            {/*      validator(_, value) {*/}
            {/*        if (!value || getFieldValue("password") === value) {*/}
            {/*          return Promise.resolve();*/}
            {/*        }*/}
            {/*        return Promise.reject(*/}
            {/*          new Error(*/}
            {/*            "The two passwords that you entered do not match!"*/}
            {/*          )*/}
            {/*        );*/}
            {/*      },*/}
            {/*    }),*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input.Password*/}
            {/*    value={confirmPassword}*/}
            {/*    onChange={(e) => setConfirmPassword(e.target.value)}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            {/*/!*<Form.Item*!/*/}
            {/*/!*  name="company"*!/*/}
            {/*/!*  label="Company"*!/*/}
            {/*/!*  tooltip="Please provide a company name"*!/*/}
            {/*/!*  rules={[*!/*/}
            {/*/!*    {*!/*/}
            {/*/!*      required: true,*!/*/}
            {/*/!*      message: "Please input the company name!",*!/*/}
            {/*/!*      whitespace: true,*!/*/}
            {/*/!*    },*!/*/}
            {/*/!*  ]}*!/*/}
            {/*/!*>*!/*/}
            {/*/!*  <Input*!/*/}
            {/*/!*    value={company}*!/*/}
            {/*/!*    onChange={(e) => setCompany(e.target.value)}*!/*/}
            {/*/!*  />*!/*/}
            {/*/!*</Form.Item>*!/*/}

            {/*<Form.Item*/}
            {/*  name="company"*/}
            {/*  label="Company"*/}
            {/*  tooltip="Please specify a company"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: company ? null : true,*/}
            {/*      message: "Please input the company!",*/}
            {/*      whitespace: true,*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Space*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*    }}*/}
            {/*    direction="vertical"*/}
            {/*  >*/}
            {/*    <Select*/}
            {/*      mode="single"*/}
            {/*      style={{*/}
            {/*        width: "100%",*/}
            {/*      }}*/}
            {/*      placeholder="Please select"*/}
            {/*      // defaultValue={clients}*/}
            {/*      onChange={handleChange4}*/}
            {/*      options={societatiPaza}*/}
            {/*    />*/}
            {/*  </Space>*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="clients"*/}
            {/*  label="Clients"*/}
            {/*  tooltip="Please specify at least one client"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: false,*/}
            {/*      message: "Please input the clients!",*/}
            {/*      whitespace: true,*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Space*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*    }}*/}
            {/*    direction="vertical"*/}
            {/*  >*/}
            {/*    <Select*/}
            {/*      mode="multiple"*/}
            {/*      style={{*/}
            {/*        width: "100%",*/}
            {/*      }}*/}
            {/*      placeholder="Please select"*/}
            {/*      // defaultValue={clients}*/}
            {/*      onChange={handleChange2}*/}
            {/*      options={options}*/}
            {/*    />*/}
            {/*  </Space>*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="locations"*/}
            {/*  label="Locations"*/}
            {/*  tooltip="Please specify at least one location"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: false,*/}
            {/*      message: "Please input the locations!",*/}
            {/*      whitespace: true,*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Space*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*    }}*/}
            {/*    direction="vertical"*/}
            {/*  >*/}
            {/*    {loading ? (*/}
            {/*      <Spinner height="auto" size="default" />*/}
            {/*    ) : (*/}
            {/*      <Select*/}
            {/*        mode="multiple"*/}
            {/*        allowClear*/}
            {/*        style={{*/}
            {/*          width: "100%",*/}
            {/*        }}*/}
            {/*        placeholder="Please select"*/}
            {/*        value={initialLocations.map((location) => {*/}
            {/*          return {*/}
            {/*            label: location.locationName,*/}
            {/*            value: location.id,*/}
            {/*          };*/}
            {/*        })}*/}
            {/*        // defaultValue={availableLocations}*/}
            {/*        onChange={handleChange3}*/}
            {/*        options={availableLocations}*/}
            {/*      />*/}
            {/*    )}*/}
            {/*  </Space>*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="email"*/}
            {/*  label="E-mail"*/}
            {/*  tooltip="Please add an email if you want to create an administrator"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      type: "email",*/}
            {/*      message: "The input is not valid E-mail!",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input value={email} onChange={(e) => setEmail(e.target.value)} />*/}
            {/*</Form.Item>*/}

            {/*<Form.Item name="phone" label="Phone Number">*/}
            {/*  <Input*/}
            {/*    value={phoneNumber}*/}
            {/*    onChange={(e) => setPhoneNumber(e.target.value)}*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="intro"*/}
            {/*  label="Description"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: false,*/}
            {/*      message: "Please input Description",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input.TextArea*/}
            {/*    value={description}*/}
            {/*    onChange={(e) => setDescription(e.target.value)}*/}
            {/*    showCount*/}
            {/*    maxLength={100}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            {/*<Form.Item*/}
            {/*  name="role"*/}
            {/*  label="Role"*/}
            {/*  initialValue="User"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Please select role!",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Select*/}
            {/*    defaultValue="ROLE_USER"*/}
            {/*    placeholder="Select the role"*/}
            {/*    value={role}*/}
            {/*    options={[*/}
            {/*      { value: "ROLE_USER", label: "User" },*/}
            {/*      { value: "ROLE_ADMIN", label: "Admin" },*/}
            {/*    ]}*/}
            {/*    onChange={(value) => setRole([value])}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            {/*<Form.Item label="Needs NFC" initialValue={needsNFC}>*/}
            {/*  <CustomSwitch*/}
            {/*    checked={needsNFC}*/}
            {/*    onChange={(e) => setNeedsNFC(e)}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="secondary"
                className="tag-primary"
                htmlType="submit"
                onClick={() => addCompany()}
              >
                Create Company
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </>
  );
}

export default AddCompany;
